import React, { useEffect, useState } from "react";
import { Listbox } from "@headlessui/react";
import { MdBrightnessMedium, MdWbSunny, MdBrightness3 } from "react-icons/md";
import { FormikProps } from "formik";
import { dayTimeEnum } from "../../utils/enums";

interface props {
  formik: FormikProps<any>;
  data: any;
  index: number;
  removeValue: (value: any) => void;
}

function PrescriptionScheduler({ formik, data, index, removeValue }: props) {
  const tabletNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const noOfDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const [show, setshow] = useState(true);

  const [selectedNumber, setSelectedNumber] = useState(tabletNumber[0]);
  const [selectedNumberOfDays, setSelectedNumberOfDays] = useState(noOfDays[0]);

  function selectTablet(num: number) {
    const newData = data;
    newData.numberOfTablets = num;
    const newPrescriptions = [...formik.values.prescriptions];
    newPrescriptions[index] = newData;
    formik.setFieldValue("prescriptions", newPrescriptions);
  }

  function selectDays(num: number) {
    const newData = data;
    newData.lengthOfDays = num;
    const newPrescriptions = [...formik.values.prescriptions];
    newPrescriptions[index] = newData;
    formik.setFieldValue("prescriptions", newPrescriptions);
  }

  function selectTimeOfDay(value: dayTimeEnum) {
    const newData = data;
    if (newData.timesOfUsage.includes(value)) {
      const newTimes = newData.timesOfUsage.filter((x) => x !== value);
      newData.timesOfUsage = newTimes;
      const newPrescriptions = [...formik.values.prescriptions];
      newPrescriptions[index] = newData;
      formik.setFieldValue("prescriptions", newPrescriptions);
    } else {
      newData.timesOfUsage.push(value);
      const newPrescriptions = [...formik.values.prescriptions];
      newPrescriptions[index] = newData;
      formik.setFieldValue("prescriptions", newPrescriptions);
    }
  }

  return (
    <div className="w-full">
      <div className="bg-gray-100 min-w-[7rem] h-8 border flex w-full justify-between items-center rounded-md overflow-hidden">
        <button
          type="button"
          onClick={() => setshow(!show)}
          className="px-2 w-full"
        >
          {typeof data === "number" || typeof data === "string"
            ? data
            : data.name}
        </button>
        <button
          type="button"
          className="hover:text-red-500 text-2xl hover:bg-gray-300 hover:bg-opacity-50 px-2 "
          onClick={() => removeValue(data)}
        >
          &times;
        </button>
      </div>

      {show && (
        <>
          <div className="grid grid-cols-2 gap-x-12 mb-8 text-white">
            <div>
              <p className="mb-2">How many</p>

              <Listbox
                as="div"
                className="flex flex-col items-start border-b-2 border-b-[#4285F4] py-4 px-4 bg-[#D4E2FA] dark:text-black bottom-1"
                value={selectedNumber}
                onChange={setSelectedNumber}
                horizontal
              >
                <Listbox.Button>
                  {formik.values.prescriptions[index]?.numberOfTablets} tablets
                </Listbox.Button>
                <Listbox.Options className="">
                  {tabletNumber.map((n, i) => (
                    <Listbox.Option key={i} value={n} className="mt-3">
                      <button onClick={() => selectTablet(n)}>
                        {n} tablets
                      </button>
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Listbox>
              {Array.isArray(formik.errors?.prescriptions) && (
                <small className="text-red-500">
                  {/* @ts-ignore */}
                  {formik.errors?.prescriptions[index]?.numberOfTablets}
                </small>
              )}
            </div>

            <div>
              <p className="mb-2">How long</p>
              <Listbox
                as="div"
                className="flex flex-col items-start border-b-2 border-b-[#4285F4] py-4 px-4 bg-[#D4E2FA] dark:text-black"
                value={selectedNumberOfDays}
                onChange={setSelectedNumberOfDays}
                horizontal
              >
                <Listbox.Button>
                  {formik?.values?.prescriptions[index]?.lengthOfDays} days
                </Listbox.Button>
                <Listbox.Options>
                  {noOfDays.map((n, i) => (
                    <Listbox.Option key={i} value={n} className="mt-3">
                      <button onClick={() => selectDays(n)}>{n} days</button>
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Listbox>
              {Array.isArray(formik.errors?.prescriptions) && (
                <small className="text-red-500">
                  {/* @ts-ignore */}
                  {formik.errors?.prescriptions[index]?.lengthOfDays}
                </small>
              )}
            </div>
          </div>

          <div className="mb-6 text-white">
            <div>
              <p className="mb-2">When to take</p>
              <div className="flex justify-between w-full">
                <label htmlFor={data?.id + "TOD1"}>
                  <input
                    type="checkbox"
                    id={data?.id + "TOD1"}
                    value={dayTimeEnum.MORNING}
                    checked={formik?.values?.prescriptions[
                      index
                    ]?.timesOfUsage?.includes(dayTimeEnum.MORNING)}
                    onChange={() => selectTimeOfDay(dayTimeEnum.MORNING)}
                  />

                  <div
                    className={`flex flex-col items-center gap-2 checkbox ${
                      formik?.values?.prescriptions[
                        index
                      ]?.timesOfUsage?.includes(dayTimeEnum.MORNING)
                        ? "text-[#4285F4]"
                        : ""
                    }`}
                    aria-hidden="true"
                  >
                    <MdBrightnessMedium
                      size={50}
                      color={
                        formik?.values?.prescriptions[
                          index
                        ]?.timesOfUsage?.includes(dayTimeEnum.MORNING)
                          ? "#4285F4"
                          : "#B3B6BA"
                      }
                    />
                    <p className="sm">Morning</p>
                  </div>
                </label>

                <label htmlFor={data?.id + "TOD2"}>
                  <input
                    type="checkbox"
                    id={data?.id + "TOD2"}
                    value={dayTimeEnum.AFTERNOON}
                    checked={formik?.values?.prescriptions[
                      index
                    ]?.timesOfUsage?.includes(dayTimeEnum.AFTERNOON)}
                    onChange={() => selectTimeOfDay(dayTimeEnum.AFTERNOON)}
                  />
                  <div
                    className={`flex flex-col items-center gap-2 checkbox ${
                      formik?.values?.prescriptions[
                        index
                      ]?.timesOfUsage?.includes(dayTimeEnum.AFTERNOON)
                        ? "text-[#4285F4]"
                        : ""
                    }`}
                    aria-hidden="true"
                  >
                    <MdWbSunny
                      size={50}
                      color={
                        formik?.values?.prescriptions[
                          index
                        ]?.timesOfUsage?.includes(dayTimeEnum.AFTERNOON)
                          ? "#4285F4"
                          : "#B3B6BA"
                      }
                    />
                    <p className="sm">Afternoon</p>
                  </div>
                </label>

                <label htmlFor={data?.id + "TOD3"}>
                  <input
                    type="checkbox"
                    id={data?.id + "TOD3"}
                    value={dayTimeEnum.NIGHT}
                    checked={formik?.values?.prescriptions[
                      index
                    ]?.timesOfUsage?.includes(dayTimeEnum.NIGHT)}
                    onChange={() => selectTimeOfDay(dayTimeEnum.NIGHT)}
                  />

                  <div
                    className={`flex flex-col items-center gap-2 checkbox ${
                      formik?.values?.prescriptions[
                        index
                      ]?.timesOfUsage?.includes(dayTimeEnum.NIGHT)
                        ? "text-[#4285F4]"
                        : ""
                    }`}
                    aria-hidden="true"
                  >
                    <MdBrightness3
                      size={50}
                      color={
                        formik?.values?.prescriptions[
                          index
                        ]?.timesOfUsage?.includes(dayTimeEnum.NIGHT)
                          ? "#4285F4"
                          : "#B3B6BA"
                      }
                    />
                    <p className="sm">Evening</p>
                  </div>
                </label>
              </div>
              {Array.isArray(formik.errors?.prescriptions) && (
                <small className="text-red-500">
                  {/* @ts-ignore */}
                  {formik.errors?.prescriptions[index]?.timesOfUsage}
                </small>
              )}
              {/* <img /> */}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default React.memo(PrescriptionScheduler);
